import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import moment from 'moment';
import { EventsProvider } from '../../providers/events/events';
import { Platform } from 'ionic-angular/platform/platform';
import Popper from 'popper.js';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { PopoverController } from 'ionic-angular';
/**
 * Generated class for the CoEventsMonthDesktopComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-events-month-desktop',
  templateUrl: 'co-events-month-desktop.html',
  inputs: ['currentDate']
})
export class CoEventsMonthDesktopComponent {
  @Input('popOverFilter') popOverFilter: any;
  @Input('currentDate') currentDate: any;
  monthDays: any = [];
  startingDay: any;
  endingDay: any;
  rawQueryData: any;
  filteredWeek: any;
  searchTypes: any;
  eventsArray: any;
  currentPopper: any;
  currentEvent: any;
  clientKeyword: string;
  viewType: any;
  currentDay: any;
  todaysDate: any;
  showKeywordBox: boolean = false;
  searchForKeyword: string;
  @Output() onDatePicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() eventQueryTimeArgs: EventEmitter<any> = new EventEmitter<any>();
  @Output() keywordSearchEmit: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('eventSnapshotPopper') popper;
  aboveWidthBreakpoint: any;
  public devWidth = this.platform.width();
  eventsToShow: number = 5;

  constructor(private eventsProvider: EventsProvider, private platform: Platform, private clientDetails: ClientDetailsProvider, public popoverCtrl: PopoverController) {
    let self = this;

    this.clientDetails.load().then(function (response) {
      self.clientKeyword = response.keyword;
      self.viewType = this.state.mode;
      self.platform.width() > 992 ? self.aboveWidthBreakpoint = true : self.aboveWidthBreakpoint = false;
    });
  }

  ngOnInit() {
    this.todaysDate = moment();
    this.currentDay = moment(this.currentDate);
    this.initializeCalendar(this.currentDay);
  }

  initializeCalendar(currentDate) {
    let eventsQueryArgs = `startDate: "${moment(currentDate).startOf('month').startOf('week').startOf('day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment(currentDate).add(41, 'day').endOf('day').format("YYYY-MM-DD HH:mm:ss")}"`;
    this.queryEvents(eventsQueryArgs);
    this.startingDay = moment(currentDate).startOf('month').startOf('week');
    this.endingDay = moment(this.startingDay).add(42, 'day');
    this.updateBrochureStartDay();
  }

  updateBrochureStartDay(){
    this.eventQueryTimeArgs.emit({start: moment(this.currentDate).startOf('month').startOf('week').format("YYYY-MM-DD"), end: moment(this.startingDay).add(42, 'day').format("YYYY-MM-DD")});
  }

  updateKeywordFilter(){
    this.keywordSearchEmit.emit({keyword: this.searchForKeyword})
  }

  queryEvents(args) {
    let eventsResponse;
    this.eventsProvider.getEvents(args).then((res) => {
      eventsResponse = res.allEvents;
      this.rawQueryData = res.allEvents;
      this.filteredWeek = res.allEvents;
      this.searchTypes = res.searchTypes;
      this.currentEvent = res.allEvents[0];

      let finalArray = [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []];
      let dayForPage = 0;

      this.monthDays = [];
      for (let i = 0; i < finalArray.length; i++) {
        this.monthDays.push(moment(this.startingDay).add(i, 'day'))
      }

      //for each day in month
      finalArray.forEach((array, i) => {
        //for each event
        let checkDay = moment(this.startingDay).add(dayForPage, 'day').dayOfYear();
        res.allEvents.forEach(event => {
          //if event start is equal to day, push
          if (checkDay === moment(event.eventStart).dayOfYear()) {
            array.push(event);
          }
        });
        dayForPage += 1;
      });

      this.eventsArray = finalArray;
      // this.filterByPopOver(this.popOverFilter);
    });

  }

  getEventColor(eventType, barOrText) {
    if (barOrText == 'text') {
      try {
        let eventTypeObject = this.searchTypes.find(object => object.name === eventType);
        return eventTypeObject.color;
      } catch (ex) {
        return "green";
      };
    } else {
      try {
        let eventTypeObject = this.searchTypes.find(object => object.name === eventType);
        return "2px solid " + eventTypeObject.color;
      } catch (ex) {
        return "green";
      };
    }
  }

  // filterByPopOver(filterObj) {
  //   this.todayEvents = this.allEvents;
  //   let filterByType;
  //   var filter = filterObj
  //   filterByType = this.todayEvents.filter((event) => {
  //     for (var key in filter) {
  //       switch (key) {
  //         case ("time"):
  //           let eventTime = moment(event.eventStart).hour().format("YYYY-MM-DD HH:mm:ss")
  //           if (Number(eventTime) > Number(filter.time.upper) || Number(eventTime) < Number(filter.time.lower)) {
  //             return false
  //           }
  //           break;
  //         case ("location"):
  //           if (!filter.location.includes(event.locationId.toString())) {
  //             return false
  //           }
  //           break;
  //         case ("ages"):
  //           if (!filter.ages.includes(event.ages.format("YYYY-MM-DD HH:mm:ss"))) {
  //             return false
  //           }
  //           break;
  //         case ("eventType"):
  //           if (!filter.eventType.includes(event.types.format("YYYY-MM-DD HH:mm:ss"))) {
  //             return false
  //           }
  //           break;
  //         case ("keyword"):
  //           let description = event.description ? event.description.toLowerCase() : "";
  //           let shortDesc = event.shortDescription ? event.shortDescription.toLowerCase() : "";
  //           let title = event.title.toLowerCase();
  //           let searchTags;
  //           if (event.searchTags) {
  //             searchTags = event.searchTags.reduce((sum, next) => {
  //               sum += next.toLowerCase();
  //             });
  //           } else {
  //             searchTags = "";
  //           };
  //           if (description.indexOf(filterObj.keyword) === -1 && shortDesc.indexOf(filterObj.keyword) === -1 && title.indexOf(filterObj.keyword) && searchTags.indexOf(filterObj.keyword) === -1) {
  //             return false;
  //           }
  //           break;
  //       }
  //     }
  //     return true;
  //   });
  //   this.todayEvents = filterByType;
  // }

  toggleHover(info, toggle, currentEvent) {
    this.currentEvent = currentEvent;
    const reference = info.target.firstChild.parentElement.parentElement.parentElement;
    const onPopper = this.popper.nativeElement;
    // this.hovering = true;
    if (toggle && onPopper != null) {
      let popper: any;
      popper = new Popper(reference, onPopper, {
        placement: 'right-start',
        modifiers: {
          keepTogether: {
            enabled: true
          }
        },
        onCreate: (data) => {
          // popper.popper.style.display = "block";
          popper.disableEventListeners();
        },
      });
      this.currentPopper = popper;

    }
    else {
      // this.hovering = false;
      // this.currentPopper.popper.style.display = "none";
      // this.currentPopper.destroy();
    }
  }

  nextMonth() {
    this.currentDay = moment(this.currentDay).add(1, 'month').format("YYYY-MM-DD HH:mm:ss");
    this.initializeCalendar(this.currentDay);
    this.onDatePicked.emit(this.currentDay);
  }

  previousMonth() {
    this.currentDay = moment(this.currentDay).subtract(1, 'month').format("YYYY-MM-DD HH:mm:ss");
    this.initializeCalendar(this.currentDay);
    this.onDatePicked.emit(this.currentDay);
  }
}



// WEBPACK FOOTER //
// ./src/components/co-events-month-desktop/co-events-month-desktop.ts